import { useQuery } from "@tanstack/react-query"
import { listCategories } from "../../categories"
import { notification } from "antd"

export const useListCategories = ({ params }) => {
    const handleError = (err) => {
        notification.error({
            key: "listCategoriesError",
            message: "Failed to retrieve cateories list"
        })
    }

    return useQuery({
        queryKey: ["listCategories", params],
        queryFn: () => listCategories(params),
        onError: handleError,
    })
}
